<template>
    <div class="news_item" >
        <img :src="data.displayImg || data.picUrl" alt="" class="img">
        <div class="content" >
            <h5>{{ data.title }}</h5>
            <p>{{ richTextToPlainText(data.contents || data.content) }}</p>
            <p class="time">
                <span v-if="data.createTime">{{ data.createTime.split('T')[0] }}</span> 
                <span v-else> </span>
                <router-link :to="url">查看详情 >></router-link>
            </p>
        </div>
    </div>
</template>
<script setup>
import { richTextToPlainText } from '@/utils/util.js'
import { useRouter } from 'vue-router';
const router = useRouter()
defineProps({
    data: {
        type: Object,
        default: () => ({})
    },
    url: {
        type: String,
        default: ''
    }
})
</script>

<style scoped lang="scss">
.news_item {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 20rem;
    position: relative;
    padding: 0 20rem;

    .img{
        width: 158rem;
        height: 106rem;
        object-fit: cover;
        position: absolute;
        left: 20rem;
    }

    .content {
        width: 308rem;
        height: 180rem;
        padding: 20rem 10rem 10rem 90rem;
        background-color: #F5F5F5;
        h5 {
            font-size: 14rem;
            color: #000;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        p {
            margin: 15rem 0;
            font-size: 12rem;
            height: 40rem;
            line-height: 20rem;
            width: 100%;
            color: #666666;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;

        }

        .time{
            display: flex; justify-content: space-between;
            a{color: #666666;}
        }
    }
}
</style>